import { Box, Card, CardActionArea, CardContent, Grid, Typography } from "@mui/material";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import MoveToInboxOutlinedIcon from "@mui/icons-material/MoveToInboxOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import DevicesOutlinedIcon from "@mui/icons-material/DevicesOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import WarehouseOutlinedIcon from "@mui/icons-material/WarehouseOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import { useNavigate } from "react-router-dom";
import { Input, LocalShipping, Logout, QrCodeScanner, ZoomIn } from "@mui/icons-material";

const Home = () => {
    const navigate = useNavigate();

    const widgets = [
        {
            title: "Sendungserfassung",
            description: "Neue Sendungen annehmen und erfassen.",
            icon: <LocalShipping fontSize="large" />,
            path: "/checkin"
        },
        {
            title: "Einlagerung",
            description: "Ein- und Umlagerungen erfassen.",
            icon: <Input fontSize="large" />,
            path: "/storage"
        },
        {
            title: "Sendungsausgabe",
            description: "Sendungen ausgeben und Vorgänge an der Kasse abwickeln.",
            icon: <Logout fontSize="large" />,
            path: "/checkout"
        },
        {
            title: "Recherche",
            description: "Recherche- und Auskunftsfunktionen schnell erreichen.",
            icon: <ZoomIn fontSize="large" />,
            path: "/recherche"
        },
        {
            title: "Inventur",
            description: "Inventur starten und Berichte aufrufen.",
            icon: <QrCodeScanner fontSize="large" />,
            path: "/inventur"
        },
        {
            title: "Warehouse",
            description: "Lageransicht und Suchfunktionen für das Warehouse.",
            icon: <WarehouseOutlinedIcon fontSize="large" />,
            path: "/warehouse"
        },
        {
            title: "Warehouse Optimize",
            description: "Lagerstruktur und Wege gezielt optimieren.",
            icon: <TuneOutlinedIcon fontSize="large" />,
            path: "/warehouse/optimize"
        }
    ];

    return (
        <Box
            sx={{
                px: { xs: 2, md: 4 },
                py: { xs: 4, md: 6 }
            }}
        >
            <Box
                sx={{
                    textAlign: "center",
                    mb: 5
                }}
            >
                <Box
                    component="img"
                    src="https://www.mypaketshop.com/wp-content/uploads/MyPaketshop_Bildmarke-512.png"
                    alt="MyPaketshop"
                    sx={{
                        width: 96,
                        height: 96,
                        mb: 2
                    }}
                />
                <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                    MyPaketshop
                </Typography>
                <Typography variant="h6" color="text.secondary">
                    Sendungsmanager
                </Typography>
            </Box>

            <Grid container spacing={2}>
                {widgets.map((widget) => (
                    <Grid item xs={12} sm={6} lg={4} key={widget.path}>
                        <Card
                            variant="outlined"
                            sx={{
                                height: "100%",
                                borderRadius: 3,
                                transition: "all 0.2s ease",
                                "&:hover": {
                                    boxShadow: 3,
                                    transform: "translateY(-2px)"
                                }
                            }}
                        >
                            <CardActionArea
                                onClick={() => navigate(widget.path)}
                                sx={{
                                    height: "100%",
                                    alignItems: "stretch"
                                }}
                            >
                                <CardContent sx={{ p: 3 }}>
                                    <Box
                                        sx={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: 52,
                                            height: 52,
                                            borderRadius: 2,
                                            backgroundColor: "action.hover",
                                            mb: 2
                                        }}
                                    >
                                        {widget.icon}
                                    </Box>

                                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                                        {widget.title}
                                    </Typography>

                                    <Typography variant="body2" color="text.secondary">
                                        {widget.description}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default Home;